"use strict";

exports.__esModule = true;
exports.getDashboardWidgets = getDashboardWidgets;
var _constants = require("../Auth/constants");
var _Widgets = require("../Widgets");
/**
 * Get an array of widgets applicable to dashboards.
 */
function getDashboardWidgets(featureFlags, accessRights) {
  if (featureFlags === void 0) {
    featureFlags = [];
  }
  if (accessRights === void 0) {
    accessRights = [];
  }
  return [_Widgets.SingleDeviceGridWidget, _Widgets.DeviceGridWidget, _Widgets.DeviceTableWidget, _Widgets.DevicePropertyWidget, _Widgets.MachineStateCountWidget, _Widgets.TimelineValueWidget, _Widgets.AdvancedTimelineValueWidget, _Widgets.AlertValueWidget, _Widgets.MetricValueWidget, _Widgets.MetricValueAggregateWidget, _Widgets.ComponentRemainingLifeWidget, _Widgets.DataItemValueWidget, _Widgets.PerformanceParameterValueWidget, _Widgets.StripeChartWidget, _Widgets.AdvancedStripeChartWidget, _Widgets.DataItemChartWidget, _Widgets.DataItemChartV2Widget, _Widgets.MetricChartWidget, _Widgets.AdvancedMetricChartWidget, _Widgets.SectionLabelWidget, _Widgets.DescriptionWidget, _Widgets.ClockWidget, _Widgets.DeviceConnectivityWidget, _Widgets.DashboardWidget, featureFlags.includes("DISABLE_MAP") ? null : _Widgets.DeviceMapWidget, _Widgets.IFrameWidget, _Widgets.GridWidget, _Widgets.ActionButtonWidget, _Widgets.ImageWidget, accessRights.includes(_constants.ACCESS_RIGHT_ENTERPRISE_DASHBOARD) ? _Widgets.PlantGridWidget : null].filter(function (widget) {
    return !!widget;
  });
}